import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../../provider";
import { API_URL } from "../../../constants";
import { useTranslation } from "../../../language";


export default function PaymentSuccessAddOn() {
  
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { state } = useAuth();
  const { t } = useTranslation();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("loading");

  const djangoSuccessUrl = `${API_URL}/api/stripe/post-success-addon/`

// --- Helper: advance onboarding ---
  const advanceOnboarding = async (stage) => {
    try {
      await axios.patch(`${API_URL}/api/onboarding/status/`, {
        onboarding_status: stage,
      });
    } catch (err) {
      console.error("Failed to advance onboarding:", err);
    }
  };

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }

    // If not logged in, redirect to login before verifying
    if (!state.token) {
      console.warn("⚠️ User not authenticated — redirecting to login");
      navigate("/Login", { state: { from: `/PaymentSuccessAddOn?session_id=${sessionId}` } });
      return;
    }

    // Verify Stripe session and update user onboarding
    const verifyPayment = async () => {
      try {
        const res = axios.post(djangoSuccessUrl, { session_id: sessionId })
        console.log("✅ Payment verified:", res.data);
        setStatus("success");
        await advanceOnboarding(2);
        setTimeout(() => navigate("/WaitingResults"), 2000);
      
     } catch (err) {
        console.error("❌ Stripe success verification failed:", err);
        setStatus("error");
      }
    };
    verifyPayment();
  }, [sessionId, navigate, state.token, djangoSuccessUrl, advanceOnboarding]);

  // --- UI States ---
  if (status === "loading")
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          {t("onb_psa_verifying")}
        </Typography>
      </Box>
    );

  if (status === "error")
    return (
      <Box textAlign="center" mt={10}>
        <Typography variant="h5" color="error" gutterBottom>
          {t("onb_psa_error_title")}
        </Typography>
        <Button variant="outlined" onClick={() => navigate("/pricing")}>
          {t("onb_psa_try_again")}
        </Button>
      </Box>
    );

  return (
    <Box textAlign="center" mt={10}>
      <Typography variant="h4" color="success.main" gutterBottom>
        🎉 {t("onb_psa_success_title")}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {t("onb_psa_redirecting")}
      </Typography>
      <CircularProgress size={30} />
    </Box>
  );
}
